<template lang="html">
  <div
    class="atlas-weather-button"
    @click="forecast">
    <div class="weather-temperature">
      <span class="temperature">
        {{ temperature }}°
      </span>
      <span class="wheater">
        <i :class="weather.icon" />
      </span>
    </div>
    <div
      class="wind-info"
      v-if="wind">
      <WindCompass
        v-if="weather.windDeg"
        :deg="weather.windDeg" />
      <span class="wind-text">
        {{ wind }} km/h
      </span>
    </div>
  </div>
</template>

<script>
import * as turf from '@turf/turf'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { getWeather } from './service'
import mixinWeather from './mixins/weather'
import WindCompass from './WindCompass'
export default {
  name: 'AtlasWeather',
  mixins: [
    mixinWeather
  ],
  components: {
    WindCompass
  },
  data () {
    return {
      zone: null,
      time: null
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/center',
      weather: 'map/weather'
    }),
    temperature () {
      return this.weather.temp ? this.convertTemperature(this.weather.temp) : ''
    },
    wind () {
      return this.weather.wind && this.weather.windDeg ? this.convertWind(this.weather.wind) : ''
    }
  },
  watch: {
    center (center) {
      if (this.shouldUpdateWeatherData(center)) this.getCenterWeather()
    }
  },
  methods: {
    ...mapActions({
      setWeather: 'map/setWeather'
    }),
    getCenterWeather () {
      if (this.center) {
        getWeather(this.center).then(res => {
          this.time = moment()
          // request zone: 5km around center
          this.zone = turf.circle(this.center, 5)
          this.setWeather(res)
        })
      }
    },
    shouldUpdateWeatherData (center) {
      // if center or zone are not defined
      if (!center || this.zone === null) {
        return true
      // if outside of latest request zone, yes update data
      } else if (!turf.booleanPointInPolygon(center, this.zone)) {
        return true
      } else {
        // inside zone, did 10 min pasted since last request?
        const minSinceLastRequest = moment().diff(this.time, 'minutes')
        if (minSinceLastRequest > 10) return true
        return false
      }
    },
    forecast () {
      const path = '/weather/' + this.weather.id.toString()
      this.$f7router.navigate(path)
    }
  },
  created () {
    this.getCenterWeather()
  }
}
</script>

<style lang="scss">
.atlas-weather-button {
  position: absolute;
  text-align: center;
  top: 0;
  right: 0;
  z-index: 100;
  padding: 5px;
  font-size: 10px;
  width: 75px;
  .weather-temperature {
    font-size: 22px;
    line-height: 28px;
    font-weight: 300;
    .temperature {
      font-family: 'Aleo';
      font-weight: normal;
    }
    .wheater {
      font-size: 18px
    }
  }
  .wind-info {
    margin-top: -3px;
    .wind-text {
      vertical-align: middle;
      line-height: 20px;
      padding-left: 3px;
    }
  }
}
</style>
